<script setup>
import { ref } from 'vue'
import AppAuthLayout from './layouts/AppAuthLayout.vue'
import AppGecotrailLayout from './layouts/AppGecotrailLayout.vue'
import { useStore } from 'vuex'
import OverlayLoader from '@/components/AppOverlayLoader.vue'

const store = useStore()
const restored = ref(false)

store.restored.then(() => {
  restored.value = true
})

// Estado de conexion REAL. navigator.onLine solo indica si hay interfaz de red:
// puede quedarse "pegado" en offline en algunos WebView, o decir "online" con
// un wifi sin internet. Ademas, los eventos online/offline solo saltan en la
// TRANSICION: si saltaba un offline transitorio, la app se quedaba bloqueada
// (sin login/recibir/enviar) hasta un refresco completo. Por eso comprobamos la
// conexion DE VERDAD alcanzando el servidor, y reevaluamos a menudo.
const setOnline = (v) => store.commit('SET_ONLINE', v)

const probeOnline = async () => {
  const url = process.env.VUE_APP_API_URL
  if (!url) {
    setOnline(typeof navigator === 'undefined' ? true : navigator.onLine !== false)
    return
  }
  try {
    // no-cors: nos vale cualquier respuesta del server (aunque sea 404/405) para
    // saber que hay conexion; solo rechaza si NO se alcanza la red. El parametro
    // unico evita que el service worker la responda desde cache.
    await fetch(`${url}?_probe=${Date.now()}`, { method: 'GET', mode: 'no-cors', cache: 'no-store' })
    setOnline(true)
  } catch (e) {
    setOnline(false)
  }
}

// Cualquier cambio de red o volver a la app dispara una re-comprobacion (no nos
// fiamos a ciegas del evento), y ademas sondeo periodico de respaldo.
window.addEventListener('online', probeOnline)
window.addEventListener('offline', probeOnline)
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') probeOnline()
})
probeOnline()
setInterval(probeOnline, 20000)
</script>

<template>
  <v-app v-if="restored">
    <overlay-loader />
    <component
      :key="$store.state.auth.user ? 'gecotrail' : 'auth'"
      :is="$store.state.auth.user ? AppGecotrailLayout : AppAuthLayout" />
  </v-app>
</template>

<style lang="stylus">

</style>
